"use strict";function createGroup$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.createGroup$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.contact.createGroup";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.4.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.4.0"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"4.6.1"},_a)),exports.createGroup$=createGroup$,exports.default=createGroup$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/contact/createGroup.js
// module id = 932
// module chunks = 106